import React,{memo} from 'react';


const SectionFormHeader = ({title,secId,pageType=null,isQuickCreate=false})=>{
    let headerClass = 'card-header cursor-pointer sectionHeader pl-1 p-2 position-relative';
    if(isQuickCreate===true){
        return false
        headerClass = 'card-header sectionHeader pl-1 p-2 position-relative bg-transparent';
    }//card-header p-0 bg-transparent no-bd border-bottom mb-2
    return(
        <div className={headerClass}>
            <div className={`card-title d-flex align-items-center justify-content-between`} id={'card'+secId} data-toggle="collapse" href={`#${secId}`}> 
                {(pageType==='view')?
                    <>{title}</>
                :<h6 className="mb-0"> {title} </h6>}  
                <div className="span-mode"></div>
            </div>
        </div>
    )
}
export default memo(SectionFormHeader);